import api from "../axios/index"

const getAccountId = () => {
  return sessionStorage.getItem("acc_id")
}

// Location's own entry first, then the rest A-Z (backend order).
// `active`: true = selectable only, false = switched-off only, omit for all.
export const getLocationPlacesOfService = async (locationId, active) => {
  const accountId = getAccountId()
  const params = active === undefined ? {} : { active }
  const response = await api.get(
    `/accounts/${accountId}/locations/${locationId}/places-of-service/`,
    { params }
  )
  return response.data
}

export const createPlaceOfService = async (locationId, data) => {
  const accountId = getAccountId()
  const response = await api.post(
    `/accounts/${accountId}/locations/${locationId}/places-of-service/`,
    data
  )
  return response.data
}

// Accepts `name` and/or `active`.
export const updatePlaceOfService = async (placeOfServiceId, data) => {
  const accountId = getAccountId()
  const response = await api.patch(
    `/accounts/${accountId}/places-of-service/${placeOfServiceId}/`,
    data
  )
  return response.data
}
